/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelDiscounts64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelDiscounts64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            opacity="0.1"
            d="M12 15C12 13.3431 13.3431 12 15 12H49C50.6569 12 52 13.3431 52 15V49C52 50.6569 50.6569 52 49 52H15C13.3431 52 12 50.6569 12 49V15Z"
            fill="currentColor"
          />
          <g>
            <path
              d="M36.5 38C37.3284 38 38 37.3284 38 36.5C38 35.6716 37.3284 35 36.5 35C35.6716 35 35 35.6716 35 36.5C35 37.3284 35.6716 38 36.5 38Z"
              fill="currentColor"
            />
            <path
              d="M29 27.5C29 28.3284 28.3284 29 27.5 29C26.6716 29 26 28.3284 26 27.5C26 26.6716 26.6716 26 27.5 26C28.3284 26 29 26.6716 29 27.5Z"
              fill="currentColor"
            />
            <path
              d="M26.8536 37.8536L37.8536 26.8536L37.1464 26.1464L26.1464 37.1464L26.8536 37.8536Z"
              fill="currentColor"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 15C12 13.3431 13.3431 12 15 12H49C50.6569 12 52 13.3431 52 15V49C52 50.6569 50.6569 52 49 52H15C13.3431 52 12 50.6569 12 49V15ZM15 13H49C50.1046 13 51 13.8954 51 15V49C51 50.1046 50.1046 51 49 51H15C13.8954 51 13 50.1046 13 49V15C13 13.8954 13.8954 13 15 13Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelDiscounts64Icon.tags = [
  'add',
  'discounts',
  'panel',
  'shopping',
  'percentage',
];

AddPanelDiscounts64Icon.category = '64x64 (Add panel)';

AddPanelDiscounts64Icon.iconSize = 64;
